import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

interface MoveContentOrderOptions {
	id: number;
	offset: number;
}

const moveContentOrder = async ({ id, offset }: MoveContentOrderOptions) => {
	const url = `/homepage/admin/content-order/${id}/move/`;
	const response = await cmsClient.put<unknown>(url, { offset });

	return response.data;
};

const useMoveContentOrder = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		queryClient.invalidateQueries(["content-orders"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong reordering" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(moveContentOrder, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useMoveContentOrder;
